import { Component, OnInit } from '@angular/core';
import {CellEditorComponentBase} from "@shared/components/cell-components/cell-component";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {CellValue} from "@shared/models/paged-response-model";
import {CrossFieldErrorMatcher} from "@shared/models/forms.models";

@Component({
    standalone: false,
    selector: 'particle-numeric-ownership-cell-editor',
  templateUrl: './numeric-ownership-cell-editor.component.html',
  styleUrls: ['./numeric-ownership-cell-editor.component.scss']
})
export class NumericOwnershipCellEditorComponent extends CellEditorComponentBase implements OnInit {
  form: FormGroup;
  inputForm: any;
  inputFormError: any;
  errorMatcher = new CrossFieldErrorMatcher();
  totalOwnership = 0;
  canUpdateOwnership = true;
  constructor(private formBuilder: FormBuilder) {
    super();
    this.inputFormError = {
      value: {}
    };
    this.inputForm = this.formBuilder.group({
      value: ['', [Validators.required, this.validateOwnership.bind(this)]]
    });
  }

  ngOnInit() {
    if(this.item.cells['IsParent'] && this.item.cells['IsParent'].value){
      this.canUpdateOwnership = !this.item.cells['IsParent'].value;
    }
    if(this.item.cells['TotalOwnership'] && this.item.cells['TotalOwnership'].value){
      this.totalOwnership = this.item.cells['TotalOwnership'].value;
      if(this.item.cells[this.fieldDefinition.key] && this.item.cells[this.fieldDefinition.key].value){
        this.totalOwnership = this.totalOwnership - this.item.cells[this.fieldDefinition.key].value;
      }
    }
    if (this.item.cells[this.fieldDefinition.key]) {
      this.inputForm.controls['value'].setValue(this.item.cells[this.fieldDefinition.key].value);
      this.onFormValuesChanged(true);
    } else {
      this.item.cells[this.fieldDefinition.key] = <CellValue>{
        displayText: '',
        value: ''
      };
    }
    this.inputForm.valueChanges.subscribe(() => {
      if (this.item.cells[this.fieldDefinition.key]) {
        this.onFormValuesChanged();
      }
    });
  }

  onFormValuesChanged(isOnInitValueChange:boolean=false) {
    if(!this.item.cells[this.fieldDefinition.key]){
      this.item.cells[this.fieldDefinition.key] = {};
    }
    this.item.cells[this.fieldDefinition.key].value = this.inputForm.value.value;
    for (const field in this.inputForm) {
      if (!this.inputForm.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormError[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormError[field] = control.errors;
      }
    }
    this.validationChange.emit(this.inputForm.valid);
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition,isOnInitValueChange:isOnInitValueChange});
  }
  validateOwnership(form: FormControl){
    const formValue = form.value?form.value.toString():'';
    const hasAlphabet = formValue.split('').filter(ch=>isNaN(ch*1));
    if(isNaN(formValue)){
      return {
        containsAlphabet: true
      }
    }
    if(Number(formValue) > 100){
      return {
        invalidOwnership: true
      }
    }
    return null;
  }
}
